import React from "react";

type WeatherType =
  | "cloudy"
  | "fog"
  | "sleet"
  | "clear"
  | "half_clear"
  | "snow"
  | "light_rain"
  | "rain"
  | "thunder";

interface Props {
  className?: string;
  conditions: WeatherType;
}

const WeatherIcons: React.FC<Props> = (props) => {
  const renderIcon = () => {
    switch (props.conditions) {
      case "cloudy":
        return renderCloudy();
      case "fog":
        return renderFog();
      case "sleet":
        return renderSleet();
      case "clear":
        return renderClear();
      case "half_clear":
        return renderHalfClear();
      case "snow":
        return renderSnow();

      case "light_rain":
        return renderLightRain();
      case "rain":
        return renderRain();
      case "thunder":
        return renderThunder();
      default:
        return renderClear();
    }
  };
  const renderCloudy = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <g filter="url(#filter1_d)">
            <path
              fill="#E3E3E3"
              stroke="#6A6A6A"
              strokeMiterlimit="10"
              strokeWidth="10"
              d="M171.188 151.949c-9.811 0-18.283-7.912-28.808-7.912a56.377 56.377 0 00-55.013 44.287 56.377 56.377 0 00.238 25.223 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 114c-64.564-.007-58.749 37.949-74.463 37.949z"
            ></path>
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d"
            width="398"
            height="251.558"
            x="27"
            y="101"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="5"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter1_d"
            width="390"
            height="243.558"
            x="31"
            y="105"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  const renderFog = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M171.188 103.949c-9.811 0-18.283-7.912-28.808-7.912a56.376 56.376 0 00-44.229 21.484 56.38 56.38 0 00-10.546 48.026 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 66c-64.564-.007-58.749 37.949-74.463 37.949z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeWidth="10"
          d="M99 315h169M61 353h169M117 384h251M312 315h56M268 353h56"
        ></path>
        <defs>
          <filter
            id="filter0_d"
            width="390"
            height="243.558"
            x="31"
            y="57"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };
  const renderSleet = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M171.188 112.949c-9.811 0-18.283-7.912-28.808-7.912a56.377 56.377 0 00-55.013 44.287 56.377 56.377 0 00.238 25.223 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 75c-64.564-.007-58.749 37.949-74.463 37.949z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="12"
          d="M104 322l-14 13M254 322l-14 13M225 356l-14 13M321 322l-14 13M144 362l-14 13"
        ></path>
        <g
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          filter="url(#filter1_d)"
        >
          <path strokeWidth="5" d="M170.774 312v39.026"></path>
          <path
            strokeWidth="4"
            d="M176.523 314.32l-5.749 4.529M165.025 314.32l5.749 4.529"
          ></path>
          <path
            strokeWidth="4.5"
            d="M165.025 349.232l5.749-4.541M176.523 349.232l-5.749-4.541"
          ></path>
          <path strokeWidth="5" d="M153.866 321.738l33.815 19.519"></path>
          <path
            strokeWidth="4.5"
            d="M158.749 317.933l1.054 7.251M153 327.894l6.803-2.71M183.251 345.343l-1.054-7.238M189 335.395l-6.803 2.71"
          ></path>
          <path strokeWidth="5" d="M153.866 341.53l33.815-19.519"></path>
          <path
            strokeWidth="4.5"
            d="M153 335.395l6.803 2.71M158.749 345.343l1.054-7.238M189 327.894l-6.803-2.709M183.251 317.933l-1.054 7.251"
          ></path>
        </g>
        <g
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          filter="url(#filter2_d)"
        >
          <path strokeWidth="5" d="M271.774 349v39.026"></path>
          <path
            strokeWidth="4"
            d="M277.523 351.32l-5.749 4.529M266.025 351.32l5.749 4.529"
          ></path>
          <path
            strokeWidth="4.5"
            d="M266.025 386.232l5.749-4.541M277.523 386.232l-5.749-4.541"
          ></path>
          <path strokeWidth="5" d="M254.866 358.738l33.815 19.519"></path>
          <path
            strokeWidth="4.5"
            d="M259.749 354.933l1.054 7.251M254 364.894l6.803-2.71M284.251 382.343l-1.054-7.238M290 372.395l-6.803 2.71"
          ></path>
          <path strokeWidth="5" d="M254.866 378.53l33.815-19.519"></path>
          <path
            strokeWidth="4.5"
            d="M254 372.395l6.803 2.71M259.749 382.343l1.054-7.238M290 364.894l-6.803-2.709M284.251 354.933l-1.054 7.251"
          ></path>
        </g>
        <defs>
          <filter
            id="filter0_d"
            width="390"
            height="243.558"
            x="31"
            y="66"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter1_d"
            width="52.501"
            height="56.026"
            x="145.75"
            y="305.5"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter2_d"
            width="52.501"
            height="56.026"
            x="246.75"
            y="342.5"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };
  const renderClear = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <circle cx="225" cy="225" r="91.429" fill="#E3E3E3"></circle>
          <circle cx="225" cy="225" r="86.429" stroke="#6A6A6A" strokeWidth="10"></circle>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="10"
          d="M225 385v-40M225 105V65M385 225h-40M133.284 138.999L105 110.714M105 225H65M105 327.57l28.284-28.284M316.428 138.999l28.285-28.285M316.429 299.286l32.766 22.943"
        ></path>
        <defs>
          <filter
            id="filter0_d"
            width="194.857"
            height="194.857"
            x="128.571"
            y="129.571"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };
  const renderHalfClear = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M229.174 210.161c-8.079 0-15.055-6.516-23.722-6.516a46.432 46.432 0 00-45.3 36.469 46.425 46.425 0 00.196 20.769 51.034 51.034 0 00-21.11 87.702 51.037 51.037 0 0033.747 12.768h200.992a51.024 51.024 0 000-102.046c-2.691 0-7.727-.636-7.727-4.636a75.762 75.762 0 00-75.759-75.759c-53.165-.006-48.377 31.249-61.317 31.249z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="10"
          d="M70.45 124.365l24.508 27.412M175.04 88l-.562 36.767M283.085 133.502l-27.777 24.095M83.08 297.142l-27.776 24.095M61.768 219.842l-36.768.5"
        ></path>
        <g filter="url(#filter1_d)">
          <path
            fill="#6A6A6A"
            d="M234.044 179.771a79.037 79.037 0 10-122.419 100.007l10.625-8.68a65.317 65.317 0 01101.168-82.647l10.626-8.68z"
          ></path>
        </g>
        <defs>
          <filter
            id="filter0_d"
            width="325.029"
            height="204.441"
            x="111.971"
            y="169.912"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter1_d"
            width="232.422"
            height="221.217"
            x="32.621"
            y="91.561"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="3"></feOffset>
            <feGaussianBlur stdDeviation="15"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  const renderSnow = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          filter="url(#filter0_d)"
        >
          <path strokeWidth="17" d="M301.059 142v167"></path>
          <path
            strokeWidth="15"
            d="M325.66 151.929l-24.601 19.379M276.458 151.929l24.601 19.379M276.458 301.325l24.601-19.432M325.66 301.325l-24.601-19.432"
          ></path>
          <path strokeWidth="17" d="M228.704 183.672L373.41 267.2"></path>
          <path
            strokeWidth="15"
            d="M249.601 167.39l4.509 31.027M225 210.014l29.113-11.596M354.448 284.682l-4.509-30.974M379.053 242.114l-29.114 11.595"
          ></path>
          <path strokeWidth="17" d="M228.704 268.366l144.706-83.528"></path>
          <path
            strokeWidth="15"
            d="M225 242.114l29.113 11.595M249.601 284.682l4.509-30.974M379.053 210.016l-29.114-11.595M354.448 167.39l-4.509 31.027"
          ></path>
        </g>
        <g
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          filter="url(#filter1_d)"
        >
          <path strokeWidth="13" d="M145.309 267v119.245"></path>
          <path
            strokeWidth="11"
            d="M162.875 274.09l-17.566 13.837M127.743 274.09l17.566 13.837M127.743 380.765l17.566-13.876M162.875 380.765l-17.566-13.876"
          ></path>
          <path strokeWidth="13" d="M93.645 296.756l103.326 59.642"></path>
          <path
            strokeWidth="11"
            d="M108.566 285.129l3.22 22.155M91 315.564l20.788-8.279M183.431 368.881l-3.219-22.117M201 338.485l-20.788 8.28"
          ></path>
          <path strokeWidth="13" d="M93.645 357.23l103.326-59.642"></path>
          <path
            strokeWidth="11"
            d="M91 338.485l20.788 8.28M108.566 368.881l3.22-22.117M201 315.566l-20.788-8.279M183.431 285.129l-3.219 22.155"
          ></path>
        </g>
        <g
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          filter="url(#filter2_d)"
        >
          <path strokeWidth="10" d="M172.548 64v78.051"></path>
          <path
            strokeWidth="8"
            d="M184.046 68.64l-11.498 9.058M161.05 68.64l11.498 9.058M161.05 138.464l11.498-9.082M184.046 138.464l-11.498-9.082"
          ></path>
          <path strokeWidth="10" d="M138.731 83.477l67.632 39.038"></path>
          <path
            strokeWidth="8"
            d="M148.498 75.866l2.107 14.502M137 95.788l13.607-5.42M197.501 130.686l-2.108-14.477M209 110.79l-13.607 5.42"
          ></path>
          <path strokeWidth="10" d="M138.731 123.06l67.632-39.039"></path>
          <path
            strokeWidth="8"
            d="M137 110.79l13.607 5.42M148.498 130.686l2.107-14.477M209 95.789l-13.607-5.42M197.501 75.866l-2.108 14.502"
          ></path>
        </g>
        <defs>
          <filter
            id="filter0_d"
            width="181.057"
            height="196"
            x="212.498"
            y="129.5"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter1_d"
            width="133.003"
            height="144.245"
            x="80.499"
            y="256.5"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter2_d"
            width="92.002"
            height="100.051"
            x="127.999"
            y="55"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  const renderLightRain = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M171.188 92.95c-9.811 0-18.283-7.913-28.808-7.913a56.381 56.381 0 00-54.775 69.51 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 55c-64.564-.007-58.749 37.95-74.463 37.95z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="12"
          d="M104 302l-14 13M184 302l-14 13M254 302l-14 13M225 336l-14 13M321 302l-14 13M285 342l-14 13M151 336l-14 13"
        ></path>
        <defs>
          <filter
            id="filter0_d"
            width="390"
            height="243.558"
            x="31"
            y="46"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  const renderRain = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M171.188 92.95c-9.811 0-18.283-7.913-28.808-7.913a56.381 56.381 0 00-54.775 69.51 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 55c-64.564-.007-58.749 37.95-74.463 37.95z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="12"
          d="M104 302l-21 21M192 302l-68 68M278 302l-21 21M224 362l-33 33M366 302l-52 52"
        ></path>
        <defs>
          <filter
            id="filter0_d"
            width="390"
            height="243.558"
            x="31"
            y="46"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  const renderThunder = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M171.188 92.95c-9.811 0-18.283-7.913-28.808-7.913a56.381 56.381 0 00-54.775 69.51 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 55c-64.564-.007-58.749 37.95-74.463 37.95z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="12"
          d="M104 302l-21 21M192 302l-68 68M278 302l-21 21M224 362l-33 33"
        ></path>
        <path
          fill="#6A6A6A"
          d="M277.927 413.084l27.188-55.798-20.928-10.197 78.951-55.685-27.187 55.798 20.927 10.196-78.951 55.686z"
        ></path>
        <defs>
          <filter
            id="filter0_d"
            width="390"
            height="243.558"
            x="31"
            y="46"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="450"
      height="450"
      fill="none"
      viewBox="0 0 450 450"
    >
      {renderIcon()}
    </svg>
  );
};

export default WeatherIcons;

export const WeatherIconsRawContent: React.FC<Props> = (props) => {
  const renderIcon = () => {
    switch (props.conditions) {
      case "cloudy":
        return renderCloudy();
      case "fog":
        return renderFog();
      case "sleet":
        return renderSleet();
      case "clear":
        return renderClear();
      case "half_clear":
        return renderHalfClear();
      case "snow":
        return renderSnow();

      case "light_rain":
        return renderLightRain();
      case "rain":
        return renderRain();
      case "thunder":
        return renderThunder();
      default:
        return renderClear();
    }
  };
  const renderCloudy = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <g filter="url(#filter1_d)">
            <path
              fill="#E3E3E3"
              stroke="#6A6A6A"
              strokeMiterlimit="10"
              strokeWidth="10"
              d="M171.188 151.949c-9.811 0-18.283-7.912-28.808-7.912a56.377 56.377 0 00-55.013 44.287 56.377 56.377 0 00.238 25.223 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 114c-64.564-.007-58.749 37.949-74.463 37.949z"
            ></path>
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d"
            width="398"
            height="251.558"
            x="27"
            y="101"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="5"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter1_d"
            width="390"
            height="243.558"
            x="31"
            y="105"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  const renderFog = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M171.188 103.949c-9.811 0-18.283-7.912-28.808-7.912a56.376 56.376 0 00-44.229 21.484 56.38 56.38 0 00-10.546 48.026 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 66c-64.564-.007-58.749 37.949-74.463 37.949z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeWidth="10"
          d="M99 315h169M61 353h169M117 384h251M312 315h56M268 353h56"
        ></path>
        <defs>
          <filter
            id="filter0_d"
            width="390"
            height="243.558"
            x="31"
            y="57"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };
  const renderSleet = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M171.188 112.949c-9.811 0-18.283-7.912-28.808-7.912a56.377 56.377 0 00-55.013 44.287 56.377 56.377 0 00.238 25.223 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 75c-64.564-.007-58.749 37.949-74.463 37.949z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="12"
          d="M104 322l-14 13M254 322l-14 13M225 356l-14 13M321 322l-14 13M144 362l-14 13"
        ></path>
        <g
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          filter="url(#filter1_d)"
        >
          <path strokeWidth="5" d="M170.774 312v39.026"></path>
          <path
            strokeWidth="4"
            d="M176.523 314.32l-5.749 4.529M165.025 314.32l5.749 4.529"
          ></path>
          <path
            strokeWidth="4.5"
            d="M165.025 349.232l5.749-4.541M176.523 349.232l-5.749-4.541"
          ></path>
          <path strokeWidth="5" d="M153.866 321.738l33.815 19.519"></path>
          <path
            strokeWidth="4.5"
            d="M158.749 317.933l1.054 7.251M153 327.894l6.803-2.71M183.251 345.343l-1.054-7.238M189 335.395l-6.803 2.71"
          ></path>
          <path strokeWidth="5" d="M153.866 341.53l33.815-19.519"></path>
          <path
            strokeWidth="4.5"
            d="M153 335.395l6.803 2.71M158.749 345.343l1.054-7.238M189 327.894l-6.803-2.709M183.251 317.933l-1.054 7.251"
          ></path>
        </g>
        <g
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          filter="url(#filter2_d)"
        >
          <path strokeWidth="5" d="M271.774 349v39.026"></path>
          <path
            strokeWidth="4"
            d="M277.523 351.32l-5.749 4.529M266.025 351.32l5.749 4.529"
          ></path>
          <path
            strokeWidth="4.5"
            d="M266.025 386.232l5.749-4.541M277.523 386.232l-5.749-4.541"
          ></path>
          <path strokeWidth="5" d="M254.866 358.738l33.815 19.519"></path>
          <path
            strokeWidth="4.5"
            d="M259.749 354.933l1.054 7.251M254 364.894l6.803-2.71M284.251 382.343l-1.054-7.238M290 372.395l-6.803 2.71"
          ></path>
          <path strokeWidth="5" d="M254.866 378.53l33.815-19.519"></path>
          <path
            strokeWidth="4.5"
            d="M254 372.395l6.803 2.71M259.749 382.343l1.054-7.238M290 364.894l-6.803-2.709M284.251 354.933l-1.054 7.251"
          ></path>
        </g>
        <defs>
          <filter
            id="filter0_d"
            width="390"
            height="243.558"
            x="31"
            y="66"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter1_d"
            width="52.501"
            height="56.026"
            x="145.75"
            y="305.5"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter2_d"
            width="52.501"
            height="56.026"
            x="246.75"
            y="342.5"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };
  const renderClear = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <circle cx="225" cy="225" r="91.429" fill="#E3E3E3"></circle>
          <circle cx="225" cy="225" r="86.429" stroke="#6A6A6A" strokeWidth="10"></circle>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="10"
          d="M225 385v-40M225 105V65M385 225h-40M133.284 138.999L105 110.714M105 225H65M105 327.57l28.284-28.284M316.428 138.999l28.285-28.285M316.429 299.286l32.766 22.943"
        ></path>
        <defs>
          <filter
            id="filter0_d"
            width="194.857"
            height="194.857"
            x="128.571"
            y="129.571"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };
  const renderHalfClear = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M229.174 210.161c-8.079 0-15.055-6.516-23.722-6.516a46.432 46.432 0 00-45.3 36.469 46.425 46.425 0 00.196 20.769 51.034 51.034 0 00-21.11 87.702 51.037 51.037 0 0033.747 12.768h200.992a51.024 51.024 0 000-102.046c-2.691 0-7.727-.636-7.727-4.636a75.762 75.762 0 00-75.759-75.759c-53.165-.006-48.377 31.249-61.317 31.249z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="10"
          d="M70.45 124.365l24.508 27.412M175.04 88l-.562 36.767M283.085 133.502l-27.777 24.095M83.08 297.142l-27.776 24.095M61.768 219.842l-36.768.5"
        ></path>
        <g filter="url(#filter1_d)">
          <path
            fill="#6A6A6A"
            d="M234.044 179.771a79.037 79.037 0 10-122.419 100.007l10.625-8.68a65.317 65.317 0 01101.168-82.647l10.626-8.68z"
          ></path>
        </g>
        <defs>
          <filter
            id="filter0_d"
            width="325.029"
            height="204.441"
            x="111.971"
            y="169.912"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter1_d"
            width="232.422"
            height="221.217"
            x="32.621"
            y="91.561"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="3"></feOffset>
            <feGaussianBlur stdDeviation="15"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  const renderSnow = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          filter="url(#filter0_d)"
        >
          <path strokeWidth="17" d="M301.059 142v167"></path>
          <path
            strokeWidth="15"
            d="M325.66 151.929l-24.601 19.379M276.458 151.929l24.601 19.379M276.458 301.325l24.601-19.432M325.66 301.325l-24.601-19.432"
          ></path>
          <path strokeWidth="17" d="M228.704 183.672L373.41 267.2"></path>
          <path
            strokeWidth="15"
            d="M249.601 167.39l4.509 31.027M225 210.014l29.113-11.596M354.448 284.682l-4.509-30.974M379.053 242.114l-29.114 11.595"
          ></path>
          <path strokeWidth="17" d="M228.704 268.366l144.706-83.528"></path>
          <path
            strokeWidth="15"
            d="M225 242.114l29.113 11.595M249.601 284.682l4.509-30.974M379.053 210.016l-29.114-11.595M354.448 167.39l-4.509 31.027"
          ></path>
        </g>
        <g
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          filter="url(#filter1_d)"
        >
          <path strokeWidth="13" d="M145.309 267v119.245"></path>
          <path
            strokeWidth="11"
            d="M162.875 274.09l-17.566 13.837M127.743 274.09l17.566 13.837M127.743 380.765l17.566-13.876M162.875 380.765l-17.566-13.876"
          ></path>
          <path strokeWidth="13" d="M93.645 296.756l103.326 59.642"></path>
          <path
            strokeWidth="11"
            d="M108.566 285.129l3.22 22.155M91 315.564l20.788-8.279M183.431 368.881l-3.219-22.117M201 338.485l-20.788 8.28"
          ></path>
          <path strokeWidth="13" d="M93.645 357.23l103.326-59.642"></path>
          <path
            strokeWidth="11"
            d="M91 338.485l20.788 8.28M108.566 368.881l3.22-22.117M201 315.566l-20.788-8.279M183.431 285.129l-3.219 22.155"
          ></path>
        </g>
        <g
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          filter="url(#filter2_d)"
        >
          <path strokeWidth="10" d="M172.548 64v78.051"></path>
          <path
            strokeWidth="8"
            d="M184.046 68.64l-11.498 9.058M161.05 68.64l11.498 9.058M161.05 138.464l11.498-9.082M184.046 138.464l-11.498-9.082"
          ></path>
          <path strokeWidth="10" d="M138.731 83.477l67.632 39.038"></path>
          <path
            strokeWidth="8"
            d="M148.498 75.866l2.107 14.502M137 95.788l13.607-5.42M197.501 130.686l-2.108-14.477M209 110.79l-13.607 5.42"
          ></path>
          <path strokeWidth="10" d="M138.731 123.06l67.632-39.039"></path>
          <path
            strokeWidth="8"
            d="M137 110.79l13.607 5.42M148.498 130.686l2.107-14.477M209 95.789l-13.607-5.42M197.501 75.866l-2.108 14.502"
          ></path>
        </g>
        <defs>
          <filter
            id="filter0_d"
            width="181.057"
            height="196"
            x="212.498"
            y="129.5"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter1_d"
            width="133.003"
            height="144.245"
            x="80.499"
            y="256.5"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter
            id="filter2_d"
            width="92.002"
            height="100.051"
            x="127.999"
            y="55"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  const renderLightRain = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M171.188 92.95c-9.811 0-18.283-7.913-28.808-7.913a56.381 56.381 0 00-54.775 69.51 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 55c-64.564-.007-58.749 37.95-74.463 37.95z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="12"
          d="M104 302l-14 13M184 302l-14 13M254 302l-14 13M225 336l-14 13M321 302l-14 13M285 342l-14 13M151 336l-14 13"
        ></path>
        <defs>
          <filter
            id="filter0_d"
            width="390"
            height="243.558"
            x="31"
            y="46"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  const renderRain = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M171.188 92.95c-9.811 0-18.283-7.913-28.808-7.913a56.381 56.381 0 00-54.775 69.51 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 55c-64.564-.007-58.749 37.95-74.463 37.95z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="12"
          d="M104 302l-21 21M192 302l-68 68M278 302l-21 21M224 362l-33 33M366 302l-52 52"
        ></path>
        <defs>
          <filter
            id="filter0_d"
            width="390"
            height="243.558"
            x="31"
            y="46"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  const renderThunder = () => {
    return (
      <>
        <path fill="#fff" d="M0 0H450V450H0z"></path>
        <g filter="url(#filter0_d)">
          <path
            fill="#E3E3E3"
            stroke="#6A6A6A"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M171.188 92.95c-9.811 0-18.283-7.913-28.808-7.913a56.381 56.381 0 00-54.775 69.51 61.973 61.973 0 0015.346 122.011h244.087a61.962 61.962 0 000-123.925c-3.268 0-9.384-.773-9.384-5.63A92.002 92.002 0 00245.651 55c-64.564-.007-58.749 37.95-74.463 37.95z"
          ></path>
        </g>
        <path
          stroke="#6A6A6A"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="12"
          d="M104 302l-21 21M192 302l-68 68M278 302l-21 21M224 362l-33 33"
        ></path>
        <path
          fill="#6A6A6A"
          d="M277.927 413.084l27.188-55.798-20.928-10.197 78.951-55.685-27.187 55.798 20.927 10.196-78.951 55.686z"
        ></path>
        <defs>
          <filter
            id="filter0_d"
            width="390"
            height="243.558"
            x="31"
            y="46"
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            ></feColorMatrix>
            <feOffset dx="1" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="3"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0"></feColorMatrix>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </>
    );
  };

  return renderIcon();
};

export const getIconFromCMCode: (code: number) => WeatherType = (code: number) => {
  switch (code) {
    case 1:
    case 2:
      return "clear";
    case 3:
    case 4:
      return "half_clear";
    case 5:
    case 6:
      return "cloudy";
    case 7:
      return "fog";
    case 8:
    case 9:
    case 18:
    case 19:
      return "light_rain";
    case 10:
    case 20:
      return "rain";
    case 11:
    case 21:
      return "thunder";
    case 12:
    case 13:
    case 14:
    case 22:
    case 23:
    case 24:
      return "sleet";
    case 15:
    case 16:
    case 17:
    case 25:
    case 26:
    case 27:
      return "snow";

    default:
      return "cloudy";
  }
};
